document.addEventListener('DOMContentLoaded', () => {
  const siteMenu = document.querySelector('.site-menu');
  if (!siteMenu) return;

  const show = el => el?.classList.remove('hidden');
  const hide = el => el?.classList.add('hidden');
  const toggle = (el, shouldShow) => el?.classList.toggle('hidden', !shouldShow);

  let isMenuOpen = false;
  let isViewingSubMenu = false;

  const siteMenuToggleButton = siteMenu.querySelector('.site-menu__toggle');
  const siteMenuOpen = siteMenuToggleButton?.querySelector('.site-menu__toggle__open');
  const siteMenuClose = siteMenuToggleButton?.querySelector('.site-menu__toggle__close');
  const siteMenuBackButton = siteMenu.querySelector('.site-menu__toggle__back');
  const siteMenuMobiles = siteMenu.querySelector('.site-menu__mobiles');
  const siteMenuMainList = siteMenu.querySelector('.site-menu__mobiles__content > nav > ul');
  const siteMenuLogo = siteMenu.querySelector('.site-menu__logo');
  const siteMenuInner = siteMenu.querySelector('.site-menu__inner');
  const siteMenuLastMenu = siteMenu.querySelector('.site-menu__mobile__last-menu');

  const mainMenuButtons = siteMenu.querySelectorAll('.site-menu__mobile__main-menu');
  const subMenus = siteMenu.querySelectorAll('.site-menu__mobile__main-menu__sub');

  if (
    !siteMenuToggleButton || !siteMenuOpen || !siteMenuClose || !siteMenuBackButton ||
    !siteMenuMobiles || !siteMenuMainList || !mainMenuButtons.length || !subMenus.length
  ) return;

  // Initial state
  show(siteMenuOpen);
  hide(siteMenuClose);
  hide(siteMenuBackButton);
  subMenus.forEach(menu => hide(menu));

  // Toggle mobile menu
  siteMenuToggleButton.addEventListener('click', () => {
    isMenuOpen = !isMenuOpen;

    if (!isMenuOpen) {
      isViewingSubMenu = false;
      show(siteMenuMainList);
      subMenus.forEach(menu => hide(menu));
      hide(siteMenuBackButton);
      show(siteMenuLogo);
      show(siteMenuLastMenu);
      document.body.classList.remove('overflow-hidden');
    } else {
      document.body.classList.add('overflow-hidden');
    }

    toggle(siteMenuMobiles, isMenuOpen);
    toggle(siteMenuOpen, !isMenuOpen);
    toggle(siteMenuClose, isMenuOpen);
  });

  // Toggle submenu per main item
  mainMenuButtons.forEach(button => {
    const index = button.getAttribute('data-main-menu');
    const correspondingSubMenu = siteMenu.querySelector(`.site-menu__mobile__main-menu__sub[data-main-menu="${index}"]`);

    button.addEventListener('click', () => {
      if (!isMenuOpen || !correspondingSubMenu) return;

      isViewingSubMenu = true;
      hide(siteMenuMainList);
      subMenus.forEach(menu => hide(menu));
      hide(siteMenuLastMenu);
      show(correspondingSubMenu);
      show(siteMenuBackButton);
      show(siteMenuClose);
      hide(siteMenuLogo);
    });
  });

  // Back button
  siteMenuBackButton.addEventListener('click', () => {
    isViewingSubMenu = false;
    subMenus.forEach(menu => hide(menu));
    show(siteMenuMainList);
    show(siteMenuLastMenu);
    hide(siteMenuBackButton);
    show(siteMenuClose);
    show(siteMenuLogo);
  });

  // Accordion logic per submenu
  subMenus.forEach(accordionContainer => {
    const headings = accordionContainer.querySelectorAll('.site-menu__mobiles__locations__menu__heading');

    headings.forEach(heading => {
      heading.addEventListener('click', () => {
        const content = heading.parentElement?.querySelector('.site-menu__mobiles__locations__menu__content');
        const icon = heading.querySelector('svg');

        if (!content) return;

        const isOpen = !content.classList.contains('hidden');

        const allContents = accordionContainer.querySelectorAll('.site-menu__mobiles__locations__menu__content');
        const allIcons = accordionContainer.querySelectorAll('.site-menu__mobiles__locations__menu__heading svg');

        allContents.forEach(other => {
          if (other !== content && !other.classList.contains('hidden')) {
            other.style.height = other.scrollHeight + 'px';
            void other.offsetHeight;
            other.style.height = '0px';

            other.addEventListener('transitionend', function handler() {
              other.classList.add('hidden');
              other.style.height = '';
              other.removeEventListener('transitionend', handler);
            }, { once: true });
          }
        });

        allIcons.forEach(otherIcon => {
          if (otherIcon !== icon) {
            otherIcon.classList.remove('rotate-180');
          }
        });

        if (!isOpen) {
          content.classList.remove('hidden');
          content.style.height = '0px';
          void content.offsetHeight;
          content.style.height = content.scrollHeight + 'px';

          content.addEventListener('transitionend', function handler() {
            content.style.height = '';
            content.removeEventListener('transitionend', handler);
          }, { once: true });

          icon?.classList.add('rotate-180');
        } else {
          content.style.height = content.scrollHeight + 'px';
          void content.offsetHeight;
          content.style.height = '0px';

          content.addEventListener('transitionend', function handler() {
            content.classList.add('hidden');
            content.style.height = '';
            content.removeEventListener('transitionend', handler);
          }, { once: true });

          icon?.classList.remove('rotate-180');
        }
      });
    });
  });

  // Scroll behavior
  let lastScrollY = window.scrollY;
  let ticking = false;

  const isDesktop = () => window.innerWidth >= 768;

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    const componentOfferBlock = document.querySelector('.component-offer');

    if (!isDesktop()) {
      if (!isMenuOpen && currentScrollY > lastScrollY && currentScrollY > 50) {
        siteMenu.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        siteMenu.style.opacity = '0';
        siteMenu.style.transform = 'translateY(-90px)';
      } else {
        siteMenu.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        siteMenu.style.opacity = '1';
        siteMenu.style.transform = 'translateY(0)';
      }
    } else {
      if (siteMenuInner && componentOfferBlock) {
        siteMenuInner.style.marginTop = currentScrollY > 20 ? '-30px' : '10px';
      }
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(handleScroll);
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll);
  handleScroll();

  window.addEventListener('resize', () => {
    if (isDesktop()) {
      siteMenu.style.opacity = '';
      siteMenu.style.transform = '';
    } else {
      siteMenuInner.style.marginTop = '';
    }
  });
});